import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from 'src/makeStyles';
import ReplayIcon from '@mui/icons-material/Replay';
import { TP, PRODUCTION_VIEW_TYPES } from '../../../constants/consts';
import { useTranslation } from '../../../src/i18n';
import { colors, fontSize } from '../../../constants/styleConstants';
import TextButton from '../../../components/TextButton';
import DateFilter from './dateFilter';

const useStyles = makeStyles()(() => ({
  content: {
    backgroundColor: colors.lightGrey,
    color: colors.textColor,
    '&:hover': {
      backgroundColor: colors.blue1,
    },
  },
  selected: {
    backgroundColor: `${colors.blue1} !important`,
    borderRight: `solid 5px ${colors.blue3}`,
    '&:hover': {
      backgroundColor: colors.blue1,
    },
    color: colors.blue3,
    fontWeight: 'bold',
  },
  icon: {
    color: colors.blue3,
    fontSize: fontSize.large,
  },
  customStyle: {
    textTransform: 'none',
    fontSize: fontSize.smallTitle,
    margin: '2px 4px 2px 0px',
    marginRight: '8px',
  },
  label: {
    marginLeft: '8px',
  },
  clearAllAction: {
    width: 60,
    height: 34,
    margin: '0px 8px 0 0',
    padding: '40px 2px',
    fontSize: fontSize.smallTitle,
    color: colors.darkBlue,
  },
}));

export default function FBToggleList({
  state,
  dispatch,
  type,
  onSubmit,
  options,
  getSelectedValue,
  seasonsOptions,
  setToggleState,
  viewType,
  defaultSort,
}) {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  const selectedValue = getSelectedValue(state, type);
  const dateSort = defaultSort ? '-year' : 'year';

  const [selectedIndexToggle, setSelectedIndexToggle] = React.useState(selectedValue || null);
  React.useEffect(() => {
    setSelectedIndexToggle(selectedValue || null);
  }, [options]);

  const onSelectValue = (filterType, value) => {
    const filterTypes = {
      language_id: 'SELECT_LANGUAGE',
      subtitle_id: 'SELECT_SUBTITLE',
      country_id: 'SELECT_COUNTRY',
      year_id: 'SELECT_YEAR',
      season_id: 'SELECT_SEASON',
      sort: 'SELECT_SORT',
    };
    if (
      filterType === 'language_id' ||
      filterType === 'subtitle_id' ||
      filterType === 'country_id' ||
      filterType === 'year_id' ||
      filterType === 'season_id' ||
      filterType === 'sort'
    ) {
      dispatch({
        type: filterTypes[filterType],
        payload: {
          additionalFilters: { [filterType]: value.id },
        },
      });
    }
  };
  const handleMenuItemClick = (filterType, index, id) => {
    setSelectedIndexToggle(id);
    onSubmit && onSubmit({ filterType, selectedValue: options[index] });
    onSelectValue(filterType, options[index]);
    setToggleState(false);
  };

  const resetSelection = (filterType, index, value) => {
    setSelectedIndexToggle(value);
    onSubmit && onSubmit({ filterType, selectedValue: value });
  };
  // Toggle bar

  const toggleOptionList = options?.length > 0 && (
    <>
      {options.map((option, index) => (
        <ListItem
          button
          key={option.id}
          selected={option.id === selectedIndexToggle}
          className={option.id === selectedIndexToggle ? classes.selected : classes.content}
          onClick={() => {
            handleMenuItemClick(type, index, option.id);
          }}
        >
          <ListItemText primary={option.name} />
        </ListItem>
      ))}
      <TextButton
        className={classes.clearAllAction}
        onClick={() => {
          let defaultValue = -1;
          let defaultIndex = 0;
          if (type === 'sort') {
            const hasValue = options.filter(item => item.id === dateSort || item.id === 'work.name').length > 0;
            if (hasValue) {
              defaultIndex =
                PRODUCTION_VIEW_TYPES.PRODUCTION === viewType ? options.findIndex(item => item.id === dateSort) : 0;
              defaultValue = options[defaultIndex];
            } else {
              defaultValue = options[0];
            }
          }

          resetSelection(type, defaultIndex, defaultValue);
        }}
      >
        <ReplayIcon></ReplayIcon>
        {t(`${TP}.FORM_CLEAR_ALL`)}
      </TextButton>
    </>
  );

  return (
    <>
      {type === 'date' ? (
        <DateFilter state={state} dispatch={dispatch} onSubmit={onSubmit} seasonsOptions={seasonsOptions} />
      ) : (
        toggleOptionList
      )}
    </>
  );
}
